import type { AdminEmployee } from "../modules/types";
import { adminApiGet } from "./utils";

export const adminEmployeesApi = {
  getAll: (workspaceId?: string): Promise<AdminEmployee[]> =>
    adminApiGet<AdminEmployee[]>(
      workspaceId
        ? `/employees?workspace_id=${encodeURIComponent(workspaceId)}`
        : "/employees",
    ),

  getById: (id: string): Promise<AdminEmployee> =>
    adminApiGet<AdminEmployee>(`/employees/${id}`),
};
